import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import styles from "../styles";
import { DragIndicator } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const ChatHeader = ({
  fullscreen,
  onToggleFullscreen,
  onClose,
}: {
  fullscreen: boolean;
  onToggleFullscreen: () => void;
  onClose: () => void;
}) => (
  <Box sx={styles.header} id="draggable-chatbot">
    <Typography fontWeight="bold">LoanWatch Pulse</Typography>
    <Box>
      <Tooltip title="Drag" placement="top">
        <IconButton size="small">
          <DragIndicator sx={styles.dragIcon} />
        </IconButton>
      </Tooltip>
      <Tooltip title={fullscreen ? "Collapse" : "Expand"} placement="top">
        <IconButton size="small" onClick={onToggleFullscreen}>
          {fullscreen ? (
            <FullscreenExitIcon sx={styles.fullscreenExitIcon} />
          ) : (
            <FullscreenIcon sx={styles.fullscreenIcon} />
          )}
        </IconButton>
      </Tooltip>
      <Tooltip title="Close" placement="top">
        <IconButton size="small" sx={styles.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </Box>
  </Box>
);

export default ChatHeader;
